
const UpdateIcon = ({color ="#616161" }) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><script xmlns=""/>
<path d="M2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.67737 2.00631 11.2874 2.66082 12.4933 3.82667L14 5.33333" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.0001 2V5.33333H10.6667" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14C6.32263 13.9937 4.71265 13.3392 3.50667 12.1733L2 10.6667" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.33333 10.6666H2V14" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<script xmlns=""/></svg>
  )
}

export default UpdateIcon